import _get from 'lodash/get'
import request from '../request'
import { createAuthorization } from '../auth'

export const YOGA_HOME_HEADER = 'a6743321-fe02-4615-8422-7e538b58be85'
export const TYPE_HEADER = 'header'

export async function getScreens ({ server, auth, language }) {
  const res = await request
    .get(`${server}/admin/page-manager/screens?language[]=${language}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

export async function getScreen ({ server, auth, id }) {
  const res = await request
    .get(`${server}/admin/page-manager/screen/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

export async function createScreen ({ auth, server, data }) {
  const res = await request
    .post(`${server}/admin/page-manager/screen`)
    .send(data)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

export async function updateScreen ({
  auth, server, screenId, data,
}) {
  const res = await request
    .put(`${server}/admin/page-manager/screen/${screenId}`)
    .send(data)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}
